export default __webpack_public_path__ + "static/media/profile_pics.f21e7a93.svg";